import { faCreditCard, faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, Input, Loader } from "@mantine/core";
import B2BButton from "../../common/B2BButton";
import { BASE_URL } from "../../../api/EndPoints";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createB2BAPI } from "../../../api/Interceptor";
import "./ReviewOrder.css";

export default function ReviewOrder({
  selectedAddresses,
  delivery,
  cartData,
  cartInfo,
  isPlacingOrder,
  setPayment,
  setModalOpen,
  payment,
  handlePlaceOrder,
  permissionGranted,
  isLoading,
  loyalty,
  priceSlab,
  combo,
  calculateShippingCharge,
  valueOption,
  amount,
  handleWalletCheck,
  setAddedWallet,
  packingCharge,
  uom,
  profile,
  extraPackingChargePer2Roll
}) {
console.log(permissionGranted,"mkmkkm  review ")
  const { billLocation, shipLocation } = selectedAddresses;
  const navigate = useNavigate();
  const [wallet, setWallet] = useState(false);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
  const [rowCount, setRowCount] = useState(0);
  const [paackingCharge, setPackingCharge] = useState([]);
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const B2B_API = createB2BAPI();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const comboCartType = cartData?.find((item) => item?.combo);
  const handlePaymentChange = (event) => {
    setPayment(event.target.value);
  };




  const type = cartData[0]?.cartType;

  const calculatePackingCharge = () => {
    let totalAmount = 0;
    let totalRibAmt = 0;
    let totalAmount2 = 0;
    if (cartData[0]?.cartType === "WHOLESALE" || comboCartType) {
      cartData.forEach(item => {

        const quantity = item?.combo?.quantity || 0;
        const kgPerRoll = item?.combo?.kgPerRoll || item.kgPerRoll || 1;
        const quality2 = item?.quantity || 0;
        const kgPerRoll2 = item?.kgPerRoll || 1;



        const ribQuantityArray = Array.isArray(item?.variants)
          ? item.variants.map((v) => {
            const ribItem = v?.ribItem;
            if (ribItem && ribItem.quantity) {
              return ribItem.quantity / ribItem.kgPerRoll || 0;
            }
            return 0;
          })
          : [];
        const rib2 = cartData?.map((v) => {
          const ribItem = v?.ribItem;
          if (ribItem && ribItem.quantity) {
            return ribItem?.quantity / ribItem?.kgPerRoll;
          }
          return 0;
        })
        const totalRibQuantity = ribQuantityArray.reduce((sum, val) => sum + val, 0);
        const totalRibQuantity2 = rib2.reduce((sum, val) => sum + val, 0);
        totalAmount += quantity / kgPerRoll * item?.variants?.length || 0;
        totalAmount2 += quality2 / kgPerRoll2;

        totalRibAmt = totalRibQuantity + totalRibQuantity2;
      });
    } else {
      totalAmount = cartData.reduce((sum, item) => {
        return sum + (1);
      }, 0);
    }

    let total = Math.ceil(totalAmount)
    let total2 = Math.ceil(totalAmount2)
    let total3 = Math.ceil(totalRibAmt)
    if (total % 2 !== 0) {
      total = total + 1
    }
    if (total2 % 2 !== 0) {
      total2 = total2 + 1
    }

    if (total3 % 2 !== 0) {
      total3 = total3 + 1
    }

    const extra = Math.max(total - 2, 0) + Math.max(total2 - 2, 0) + Math.max(total3 - 2, 0)

    const totalPackk = Number(packingCharge) + extraPackingChargePer2Roll * (extra / 2)
    return totalPackk?.toFixed(2);
  };


  const subtotall = cartData.reduce((sum, item) => {
    if (item.combo) {
      const qty = item.combo.quantity * (item.variants?.length || 0);
      const unitPrice = Number(item.combo.sellingPrice) || 0;
      const rib = item?.variants?.map((v) => {
        const ribItem = v?.ribItem;
        if (ribItem && ribItem.sellingPrice && ribItem.quantity) {
          return ribItem.sellingPrice * ribItem.quantity;
        }
        return 0;
      });

      const ribTotal = _.sum(rib);
      return sum + qty * unitPrice + ribTotal;
    } else {

      const unitPrice = item.sellingPrice;
      const rib = item?.ribItem?.sellingPrice * item?.ribItem?.quantity || 0;
      return sum + unitPrice * item.quantity + rib;
    }
  }, 0);



  const handleWalletCheckChange = () => {
    setWallet((prev) => !prev);
    setAddedWallet(
      Math.min(
        parseFloat(cartInfo.total) +
        Number(calculateShippingCharge) +
        parseFloat(calculatePackingCharge()),
        amount
      )
    );
    handleWalletCheck();
  };

  const getCartType = () => {
    if (cartData[0]?.cartType === "SAMPLE") {
      return "Sample Cart";
    } else if (cartData[0]?.cartType === "SWATCH") {
      return "Swatch Cart";
    } else if (combo) {
      return "Wholesale Cart";
    } else {
      return "Wholesale Cart";
    }
  };

  const loyaltycondition = (getCartType() === "Swatch Cart" && subtotall < loyalty?.minRedeemPoints || profile?.loyaltyPoints < subtotall);
  const uoms = [...new Set(cartData?.map(item => uom[item.variantSku]))];
  const uomsCombo = [...new Set(combo?.map(item => uom[item.variants[0]?.variantSku]))];

  const mergedUoms = cartData[0]?.cartType === "WHOLESALE"
    ? [...new Set([...uoms, ...uomsCombo])].filter(Boolean)
    : [...new Set(uoms)].filter(Boolean);

  let uomDisplay = '';
  if (mergedUoms.length === 0) {
    uomDisplay = '';
  } else if (mergedUoms.length === 1) {
    uomDisplay = mergedUoms[0];
  } else {
    const allButLast = mergedUoms.slice(0, -1).join(', ');
    uomDisplay = `${allButLast} & ${mergedUoms[mergedUoms.length - 1]}`;
  }
  const totalAmount =
    subtotall +
    (delivery === "FREIGHT FORWARD" ?
      Number(calculatePackingCharge()) : 0);
  const swatchTotal = subtotall.toFixed(2) <= profile?.loyaltyAmount ? 0 + (delivery === "FREIGHT FORWARD" ?
    Number(calculatePackingCharge()) : 0) : subtotall.toFixed(2) + (delivery === "FREIGHT FORWARD" ?
      Number(calculatePackingCharge()) : 0);
  const igst = (getCartType() === "Swatch Cart" ? swatchTotal : totalAmount) * 0;
  const cgst1 = (getCartType() === "Swatch Cart" ? swatchTotal : totalAmount) * 0.025;
  const cgst = Math.floor(cgst1 * 100) / 100;
  const sgst1 = (getCartType() === "Swatch Cart" ? swatchTotal : totalAmount) * 0.025;
  const sgst = Math.floor(sgst1 * 100) / 100;
  const grandTotal1 = ((getCartType() === "Swatch Cart" ? swatchTotal : totalAmount) + igst + cgst + sgst);
  const grandTotal = Math.floor(grandTotal1 * 100) / 100;

  return (
    <>
      <div className="review-order-container">
        <div className="f-32 f-700 m-b-24 m-t-48">Review Order</div>
        <div
          className="adaptive-layout boundary-width-992 checkout-layout"
          style={{ gap: "24px" }}
        >
          <div className="first">
            <div className="view-checkout-review flex checkout-route-view">
              {/* <div className="review-payment checkout-section-box">
                            <div className="checkout-section-title checkout-section-header">
                                Payment method
                            </div>
                            <div className="checkout-section-body">
                                <div className="acceptable-methods flex g-8">
                                    <div className="acceptable-method required">
                                        <div className="row required-but-empty">
                                            <Input
                                                type="radio"
                                                value="credit-debit"
                                                checked={payment === 'credit-debit'}
                                                onChange={handlePaymentChange}
                                            />
                                            <div className="flex-row items-center">
                                                <FontAwesomeIcon icon={faCreditCard} />
                                                <span style={{ marginLeft: '6px' }}>Credit/Debit Card</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="acceptable-method required">

                                        <div className="row required-but-empty">
                                            <Input
                                                type="radio"
                                                value="bank-transfer"
                                                checked={payment === 'bank-transfer'}
                                                onChange={handlePaymentChange}
                                            />
                                            <div className="flex-row items-center">
                                                <FontAwesomeIcon icon={faRightLeft} />
                                                <span style={{ marginLeft: '6px' }} >Bank Transfer</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
              <div className="checkout-section-box">
                <div className="checkout-section-title checkout-section-header">
                  Address
                </div>
                <div
                  className="adaptive-layout boundary-width-768 order-addresses checkout-section-body"
                  style={{ gap: "16px" }}
                >
                  <div className="card">
                    <div className="badge-address-type">
                      <i className="fal fa-receipt"></i>
                      <span>Bill to</span>
                    </div>
                    <div className="c-address">
                      <div className="location-info">
                        <div>{billLocation.address1}</div>
                        <div>{billLocation.address2}</div>
                        <div>
                          {billLocation.city}, {billLocation.state}{" "}
                          {billLocation.pincode}
                        </div>
                        <div className="country">{billLocation.country}</div>
                      </div>
                      <div className="contact-info">
                        <div className="ci-row">
                          <span className="address-key">Contact Name :</span>
                          <span className="address-value">
                            {billLocation.nickName}
                          </span>
                        </div>
                        <div className="ci-row">
                          <span className="address-key">Contact Phone :</span>
                          <span className="address-value">
                            {billLocation.mobileNo}
                          </span>
                        </div>
                        <div className="ci-row">
                          <span className="address-key">Contact Email :</span>
                          <span className="address-value">
                            {billLocation.email}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {shipLocation && (
                    <div className="card">
                      <div className="badge-address-type">
                        <i className="fal fa-shipping-fast"></i>
                        <span>Ship to</span>
                      </div>
                      <div className="c-address">
                        <div className="location-info">
                          <div>{shipLocation?.address1}</div>
                          <div>{shipLocation?.address2}</div>
                          <div>
                            {shipLocation?.city}, {shipLocation?.state}{" "}
                            {shipLocation?.pincode}
                          </div>
                          <div className="country">{shipLocation?.country}</div>
                        </div>
                        <div className="contact-info">
                          <div className="ci-row">
                            <span className="address-key">Contact Name :</span>
                            <span className="address-value">
                              {shipLocation?.nickName}
                            </span>
                          </div>
                          <div className="ci-row">
                            <span className="address-key">Contact Phone :</span>
                            <span className="address-value">
                              {shipLocation?.mobileNo}
                            </span>
                          </div>
                          <div className="ci-row">
                            <span className="address-key">Contact Email :</span>
                            <span className="address-value">
                              {shipLocation?.email}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="checkout-section-box">
                <div className="checkout-section-title checkout-section-header flex-row flex-between items-center">
                  <div>Shipping</div>
                  <div className="f-14 c-gray-500" style={{ display: "flex", justifyContent: "flex-end" }}>
                    Ships from Tirupur, Tamilnadu
                  </div>
                </div>
                <div className="checkout-section-body">
                  <div className="shipping-param">
                    <div className="shipping-param-setter read-only">
                      <div className="param-item">
                        <label>
                          Transporter Name<span className="required"></span>
                          <i className="fal fa-question-circle m-l-8 f-12"></i>
                        </label>
                        <div>
                          {selectedAddresses?.shipLocation?.transporterCharges
                            ?.transporter?.name
                            ? selectedAddresses?.shipLocation?.transporterCharges
                              ?.transporter?.name
                            : "-"}
                        </div>
                      </div>
                      {/* <div className="param-item">
                      <label>Transporter Charges<span className="required"></span><i className="fal fa-question-circle m-l-8 f-12"></i></label>
                      <div> ₹ {selectedAddresses?.shipLocation?.transporterCharges?.charges ? selectedAddresses?.shipLocation?.transporterCharges?.charges : '0'}</div>
                    </div> */}
                      <div className="param-item country">
                        <div >
                          <label>
                            Country<span className="required"></span>
                          </label></div>
                        <div>
                          <img
                            src="https://raw.githubusercontent.com/lipis/flag-icon-css/d81077e4e9648ba32546fad3b77932b48feb344b/flags/4x3/in.svg"
                            style={{ width: "18px" }}
                          />{" "}
                          India
                        </div>
                      </div>
                      {/* <div className="param-item">
                      <label>
                        Shipping Fees<span className="required"></span>
                        <i className="fal fa-question-circle m-l-8 f-12"></i>
                      </label>
                      <div>
                        {" "}
                        ₹{" "}
                        {delivery === "FREIGHT FORWARD"
                          ? calculateShippingCharge
                          : "0"}
                      </div>
                    </div> */}

                      <div className="param-item">
                        <label>
                          Packing Charges / {cartData[0]?.cartType === "SWATCH" ? 'pcs' : cartData[0]?.cartType === "WHOLESALE" && comboCartType ? 'rolls' : uomDisplay}<span className="required"></span>
                          {/* Packing Charges / {getCartType()==="Swatch Cart" ? "pcs": "rolls"} */}
                          <i className="fal fa-question-circle m-l-8 f-12"></i>
                        </label>
                        <div> {getCartType() === "Swatch Cart" ? `${packingCharge || 0} points` : `₹ ${packingCharge || 0} `}</div>
                      </div>
                      {/* <div className="param-item">
                                            <label>Courier<span className="required"></span></label>
                                            <div>UPS</div>
                                        </div>
                                        <div className="param-item">
                                            <label>Incoterms<span className="required"></span><i className="fal fa-question-circle m-l-8 f-12"></i></label>
                                            <div>DAP</div>
                                        </div> */}
                    </div>
                    {/* <div className="flex">
                                        <div className="gray-box shipping-fee">
                                            <div className="attr">
                                                <div className="key">Minimum</div>
                                                <div className="value">$0.00</div>
                                            </div>
                                            <div className="attr">
                                                <div className="key">Base Fee</div>
                                                <div className="value">$13.30</div>
                                            </div>
                                        </div>
                                    </div> */}
                  </div>
                </div>
              </div>

              <div className="checkout-section-box m-b-0">
                <div className="layout-items-header">
                  <div className="checkout-section-title">
                    Cart{" "}
                    <span className="c-gray-500 f-16">({_.size(cartData)})</span>
                  </div>
                  <div className="flex-row g-16 m-l-a items-center">
                    <div className="view-types">
                      <i className="fal fa-diagram-cells selected"></i>
                      <i className="fal fa-list-ul"></i>
                    </div>
                  </div>
                </div>
                <br />
                <div className="cart-produc">
                  {cartData?.map((items, index) => {
                    if (items?.combo) {
                      return (
                        <div
                          key={index}
                          className="flex g-8 cart-item-padding p-b-8"
                        >
                          <div className="cart-product-layout">
                            <div
                              className="adaptive-layout boundary-width-768 flex-fill"
                              style={{
                                gap: "16px",
                                flexDirection: "column",
                                display: "flex",
                              }}
                            >
                              {items?.variants?.length > 0 ? (
                                <>
                                  <br />
                                  {/* <div
                                  className="text-nowrap"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "91%",
                                  }}
                                >
                                  <div className="f-600">
                                    <a className="text-underline cursor-pointer">
                                      {item?.combo?.articleCode}
                                    </a>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "190px",
                                      alignItems: "start",
                                    }}
                                  >
                                    <div style={{ fontWeight: "bold" }}>
                                      {item?.combo?.quantity *
                                        item?.variants?.length}{" "}
                                      kg
                                    </div>
                                    <div className="f-600">
                                      ₹
                                      {item.combo.quantity *
                                        item?.variants?.length *
                                        item?.combo?.sellingPrice}
                                    </div>
                                    <div style={{ fontWeight: "bold" }}>
                                      ₹{item?.combo?.sellingPrice * item?.variants?.length}/kgs
                                    </div>
                                  </div>
                                </div> */}

                                  <div className="flex g-8 cart-item-padding p-b-8 cart-item-border">
                                    <div className="cart-product-layout">
                                      <div
                                        className="adaptive-layout boundary-width-768 flex-fill g-10"
                                        style={{
                                          flexDirection: "column",
                                          display: "flex",
                                        }}
                                      >
                                        {items.variants.length > 0 ? (
                                          <>
                                            {_.map(
                                              items.variants,
                                              (variant, index) => (
                                                <>
                                                  <div className="flex g-8 cart-item-padding p-b-8">
                                                    <div className="cart-product-layout">
                                                      <div
                                                        className="adaptive-layout boundary-width-768 flex-fill"
                                                        style={{ gap: "16px" }}
                                                      >
                                                        <div
                                                          className="adaptive-layout boundary-width-768 flex-fill g-40"
                                                          style={{ gap: "0px" }}
                                                        >
                                                          <div className="flex-row items-start g-8">
                                                            <div className="wrapper-product-info">
                                                              <div className="image-container flex-wrap">
                                                                <div className="product-image-thumbnail center overlay">
                                                                  <img
                                                                    className="app-img cover"
                                                                    src={`${BASE_URL}${variant.image?.replace(
                                                                      "/api",
                                                                      ""
                                                                    )}?time=${Date?.now()}`}
                                                                    alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                                                                    loading="lazy"
                                                                  />
                                                                </div>
                                                              </div>
                                                              <div className="lcn-container">
                                                                <div className="pd-code">
                                                                  <span
                                                                    className="clickable-area"
                                                                    onClick={() => {
                                                                      if (
                                                                        items
                                                                          .combo
                                                                          .published ===
                                                                        "true"
                                                                      ) {
                                                                        navigate(
                                                                          `${items.combo.pimUrl}`
                                                                        );
                                                                      }
                                                                    }}
                                                                  >
                                                                    #{index + 1} {
                                                                      variant.name
                                                                    }
                                                                  </span>
                                                                </div>
                                                                {items.combo
                                                                  .published ===
                                                                  "false" && (
                                                                    <p
                                                                      style={{
                                                                        color:
                                                                          "red",
                                                                      }}
                                                                    >
                                                                      (Product
                                                                      unavailable)
                                                                    </p>
                                                                  )}
                                                                {items?.combo?.cartType !== "SAMPLE" && items?.combo?.cartType !== "SWATCH" && (
                                                                  <div>
                                                                    No. of Rolls :{" "}
                                                                    {items?.combo
                                                                      ?.quantity /
                                                                      items?.combo
                                                                        ?.kgPerRoll}
                                                                  </div>)}

                                                                <div>
                                                                  {uom[variant?.variantSku]}/Rolls :{" "}
                                                                  {Math.round(
                                                                    items?.combo
                                                                      ?.kgPerRoll
                                                                  )}
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="flex-kg">
                                                              <div
                                                                className="flex-row-kg-only"
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "16px",
                                                                }}
                                                              >
                                                                {
                                                                  items.combo
                                                                    .quantity
                                                                }{" "}
                                                                {uom[variant?.variantSku]}
                                                              </div>
                                                              <div className="flex-row-price">
                                                                <div
                                                                  style={{
                                                                    fontWeight:
                                                                      "bold",
                                                                    fontSize:
                                                                      "16px",
                                                                  }}
                                                                >
                                                                  &#8377;
                                                                  {(
                                                                    items.combo
                                                                      .quantity *
                                                                    items.combo
                                                                      .sellingPrice
                                                                  ).toFixed(2)}
                                                                </div>
                                                                <div className="cart-nkcom">
                                                                  &#8377;
                                                                  {(items?.combo.sellingPrice).toFixed(
                                                                    2
                                                                  )}
                                                                  /{uom[variant?.variantSku]}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  {/* ...........................................rib combo */}

                                                  {variant?.ribItem && (

                                                    <div className="flex cart-item-padding p-b-8" >
                                                      <div className="cart-product-layout">
                                                        <div className="Rib-avai-rib" style={{ fontWeight: "bold", color: "white", marginBottom: "10px" }}>RIB</div>
                                                        <div
                                                          className="adaptive-layout boundary-width-768 flex-fill"
                                                          style={{ gap: "16px" }}
                                                        >
                                                          <div
                                                            className="adaptive-layout boundary-width-768 flex-fill g-40"
                                                            style={{ gap: "0px" }}
                                                          >
                                                            <div className="flex-row items-start g-8">
                                                              <div className="wrapper-product-info">
                                                                <div className="image-container flex-wrap">
                                                                  <div className="product-image-thumbnail center overlay">
                                                                    <img
                                                                      className="app-img cover"
                                                                      src={`${BASE_URL}${variant?.ribItem?.image?.replace(
                                                                        "/api",
                                                                        ""
                                                                      )}?time=${Date?.now()}`}
                                                                      alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                                                                      loading="lazy"
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div className="lcn-container">
                                                                  <div className="pd-code">
                                                                    <span
                                                                      className="clickable-area"
                                                                      onClick={() => {
                                                                        if (
                                                                          items
                                                                            .combo
                                                                            .published ===
                                                                          "true"
                                                                        ) {
                                                                          navigate(
                                                                            `${items.combo.pimUrl}`
                                                                          );
                                                                        }
                                                                      }}
                                                                    >
                                                                      #{index + 1} {
                                                                        variant?.ribItem?.variantName
                                                                      }
                                                                    </span>
                                                                  </div>
                                                                  {items.combo
                                                                    .published ===
                                                                    "false" && (
                                                                      <p
                                                                        style={{
                                                                          color:
                                                                            "red",
                                                                        }}
                                                                      >
                                                                        (Product
                                                                        unavailable)
                                                                      </p>
                                                                    )}

                                                                  <div>
                                                                    {uom[variant?.ribItem?.variantSku]}/Rolls :{" "}
                                                                    {Math.round(
                                                                      variant?.ribItem
                                                                        ?.kgPerRoll
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="flex-kg">
                                                                <div
                                                                  className="flex-row-kg-only"
                                                                  style={{
                                                                    fontWeight:
                                                                      "bold",
                                                                    fontSize:
                                                                      "16px",
                                                                  }}
                                                                >
                                                                  {
                                                                    variant?.ribItem?.quantity
                                                                  }{" "}
                                                                  {uom[variant?.ribItem?.variantSku]}
                                                                </div>
                                                                <div className="flex-row-price">
                                                                  <div
                                                                    style={{
                                                                      fontWeight:
                                                                        "bold",
                                                                      fontSize:
                                                                        "16px",
                                                                    }}
                                                                  >
                                                                    &#8377;
                                                                    {(
                                                                      variant?.ribItem
                                                                        ?.quantity *
                                                                      variant?.ribItem
                                                                        ?.sellingPrice
                                                                    ).toFixed(2)}
                                                                  </div>
                                                                  <div className="cart-nkcom">
                                                                    &#8377;
                                                                    {(variant?.ribItem?.sellingPrice).toFixed(
                                                                      2
                                                                    )}
                                                                    /{uom[variant?.ribItem?.variantSku]}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div></div>
                                                  )}<br />
                                                  {/* .................................................... */}
                                                </>
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <p style={{ color: "red" }}>
                                              (Combo unavailable)
                                            </p>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      );
                    } else if (
                      ["WHOLESALE", "SAMPLE", "SWATCH"].includes(items.cartType)
                    ) {
                      const quantityValue =
                        uom[items.variantSku] === "kg"
                          ? (items?.quantity * metre[items.variantSku]).toFixed(2)
                          : items?.quantity;

                      const totalPrice = (
                        (items?.sellingPrice * items?.quantity).toFixed(2) /
                        quantityValue
                      ).toFixed(2);


                      return (
                        <div className="items" key={items.variantSku}>
                          <div className="cart-product separator">
                            <div className="flex g-16">
                              <div className="cart-product-layout">

                                <div
                                  className="adaptive-layout boundary-width-768 flex-fill g-10"
                                  style={{ gap: "0px" }}
                                >
                                  <div className="flex-row items-start g-8 p-b-8">
                                    <div className="wrapper-product-info">
                                      <div className="image-container flex-wrap">
                                        <div className="product-image-thumbnail center overlay">
                                          <img
                                            className="app-img cover"
                                            src={`${BASE_URL}${items.image?.replace(
                                              "/api",
                                              ""
                                            )}?time=${Date?.now()}`}
                                            alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                                            loading="lazy"
                                          />
                                        </div>
                                      </div>
                                      <div className="lcn-container">
                                        <div className="pd-code">
                                          <span
                                            className="clickable-area"
                                            onClick={() => {
                                              if (
                                                items
                                                  .published ===
                                                "true"
                                              ) {
                                                navigate(
                                                  `${items.pimUrl}`
                                                );
                                              }
                                            }}
                                          >
                                            #{index + 1} {
                                              items?.variantName
                                            }
                                          </span>
                                        </div>
                                        {items?.published ===
                                          "false" && (
                                            <p
                                              style={{
                                                color:
                                                  "red",
                                              }}
                                            >
                                              (Product
                                              unavailable)
                                            </p>
                                          )}

                                        {items?.cartType !== "SAMPLE" && items?.cartType != "SWATCH" && (<div>
                                          No. of Rolls :{" "}
                                          {items
                                            ?.quantity /
                                            items
                                              ?.kgPerRoll}
                                        </div>)}

                                        {items?.cartType === "SWATCH" && (<div>p k////
                                          Total Qty :{" "}
                                          {(items?.quantity)}
                                        </div>)}
                                        {items?.cartType !== "SWATCH" && (
                                          <div>
                                            {uom[items?.variantSku]}/Rolls :{" "}
                                            {Math.round(
                                              items
                                                ?.kgPerRoll
                                            )}
                                          </div>)}
                                      </div>
                                    </div>
                                    <div className="flex-kg">
                                      <div
                                        className="flex-row-kg-only"
                                        style={{
                                          fontWeight:
                                            "bold",
                                          fontSize:
                                            "16px",
                                        }}
                                      >
                                        {
                                          items?.quantity
                                        }{" "}
                                        {uom[items?.variantSku]}{items?.cartType === "SWATCH" && "pcs"}
                                      </div>
                                      <div className="flex-row-price">
                                        <div
                                          style={{
                                            fontWeight:
                                              "bold",
                                            fontSize:
                                              "16px",
                                          }}
                                        >
                                          {items?.cartType !== "SWATCH" && `₹`}
                                          {(
                                            items
                                              ?.quantity *
                                            (items?.sellingPrice)
                                          ).toFixed(2)}  {items?.cartType === "SWATCH" && `points`}
                                        </div>
                                        <div className="cart-nkcom">
                                          {items?.cartType !== "SWATCH" && `₹`}
                                          {((items?.sellingPrice)).toFixed(
                                            2
                                          )} {items?.cartType === "SWATCH" && `points`}
                                          /{uom[items?.variantSku]}{items?.cartType === "SWATCH" && `pcs`}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>

                            </div>

                            {/* ...................................................rib for wholsale................. */}
                            {items?.ribItem && (

                              <div className="flex cart-item-padding p-b-8" >
                                <div className="cart-product-layout">
                                  <div className="Rib-avai-rib" style={{ fontWeight: "bold", color: "white", marginBottom: "10px" }}>RIB</div>
                                  <div
                                    className="adaptive-layout boundary-width-768 flex-fill g-10"
                                  >

                                    <div className="flex-row items-start p g-8">
                                      <div className="wrapper-product-info" >
                                        <div className="image-container flex-wrap">
                                          <div className="product-image-thumbnail center overlay">
                                            <img
                                              className="app-img cover"
                                              src={`${BASE_URL}${items?.ribItem?.image?.replace(
                                                "/api",
                                                ""
                                              )}?time=${Date?.now()}`}
                                              alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                                              loading="lazy"
                                            />
                                          </div>
                                        </div>
                                        <div className="lcn-container">
                                          <div className="pd-code">
                                            <span
                                              className="clickable-area"
                                              onClick={() => {
                                                if (
                                                  items?.ribItem
                                                    .published ===
                                                  "true"
                                                ) {
                                                  navigate(
                                                    `${items?.ribItem?.pimUrl}`
                                                  );
                                                }
                                              }}
                                            >
                                              #{index + 1} {
                                                items?.ribItem?.variantName
                                              }
                                            </span>
                                          </div>
                                          {items?.ribItem?.published ===
                                            "false" && (
                                              <p
                                                style={{
                                                  color:
                                                    "red",
                                                }}
                                              >
                                                (Product
                                                unavailable)
                                              </p>
                                            )}

                                          <div>
                                            {uom[items?.ribItem?.variantSku]}/Rolls :{" "}
                                            {Math.round(
                                              items?.ribItem
                                                ?.kgPerRoll
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="flex-kg">
                                        <div
                                          className="flex-row-kg-only"
                                          style={{
                                            fontWeight:
                                              "bold",
                                            fontSize:
                                              "16px",
                                          }}
                                        >
                                          {
                                            items?.ribItem?.quantity
                                          }{" "}
                                          {uom[items?.ribItem?.variantSku]}
                                        </div>
                                        <div className="flex-row-price">
                                          <div
                                            style={{
                                              fontWeight:
                                                "bold",
                                              fontSize:
                                                "16px",
                                            }}
                                          >
                                            &#8377;
                                            {(
                                              items?.ribItem
                                                ?.quantity *
                                              (items?.ribItem?.sellingPrice)
                                            ).toFixed(2)}
                                          </div>
                                          <div className="cart-nkcom">
                                            &#8377;
                                            {((items?.ribItem?.sellingPrice)).toFixed(
                                              2
                                            )}
                                            /{uom[items?.ribItem?.variantSku]}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div></div>

                            )}

                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="second required">
            <div
              className="conditional-sticky"
              style={{
                top: "calc(16px + var(--app-header-height))",
                position: "sticky",
                marginTop: "0px",
                zIndex: "2",
              }}
            >
              <div className="cart-price-summary card-price-summary">
                <div className="header">{getCartType()}</div>
                <div className="subtotal-explanation">
                  {getCartType() === "Swatch Cart" && (
                    <div className="row">
                      <div className="key">Loyalty points : </div>
                      <div className="value" style={{ display: "flex", flexDirection: "column" }}>
                        <span>  {profile?.loyaltyAmount.toFixed(2)} points </span>

                      </div>
                    </div>)}
                  {getCartType() === "Swatch Cart" && (loyalty?.minRedeemPoints || 0) > 0 && (
                    <div className="row">
                      <div className="key">minimum redeem points :</div>
                      <div className="value" style={{ display: "flex", flexDirection: "column" }}>
                        <span>  {loyalty?.minRedeemPoints.toFixed(2)} points </span>

                      </div>
                    </div>)}
                  <div className="row">
                    <div className="key">
                      Subtotal ({cartInfo.subTotal} {cartInfo.subTotal <= 1 ? 'Product' : 'Products'}) :
                    </div>
                    <div className="value">{getCartType() !== "Swatch Cart" ? `₹ ${subtotall.toFixed(2)}` : `${subtotall.toFixed(2)} points`}  </div>
                  </div>
                  {getCartType() === "Swatch Cart" && (profile?.loyaltyAmount != null || profile?.loyaltyAmount > 0) && (
                    <div className="row">
                      <div className="key">
                        <div style={{ fontSize: "12px", color: "#888" }}>
                          ( Loyalty Points - Subtotal )
                        </div>
                        Remaining Loyalty points :
                      </div>

                      <div className="value">
                        {(
                          (profile?.loyaltyAmount || 0) - subtotall
                        ).toFixed(2)}{" "}
                        {getCartType() !== "Swatch Cart" ? "₹" : "points"}
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="key">Packing Charges :</div>
                    <div className="value">
                      ₹ {delivery != "PICKUP" ? calculatePackingCharge() : 0}
                    </div>
                  </div>
                  <div className="row">
                    <div className="key">IGST Charges (0%) :</div>
                    <div className="value">
                      ₹ {igst}
                    </div>
                  </div>
                  <div className="row">
                    <div className="key">CGST Charges (2.5%) :</div>
                    <div className="value">
                      ₹ {(cgst).toFixed(2)}
                    </div>
                  </div>
                  <div className="row">
                    <div className="key">SGST Charges (2.5%) :</div>
                    <div className="value">
                      ₹ {sgst.toFixed(2)}
                    </div>
                  </div>
                  <div className="row">
                    <div className="key">Total :</div>
                    <div className="value">
                      {
                        getCartType() === "Swatch Cart"
                          ? `${Number(grandTotal).toFixed(2)} points`
                          : `₹ ${Number(Math.round(grandTotal)).toFixed(2)}`
                      }
                    </div>
                  </div>
                </div>
                {/* <div className="total">
                <div className="row">
                  <div className="key">Total :</div>
                  <div className="value">
                  ₹ {totalAmount.toFixed(2)}
                  </div>
                </div>
              </div> */}
                {getCartType() === "Swatch Cart" && (
                  <div className="total">
                    {profile?.loyaltyAmount > subtotall ? (<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", color: "gray" }}>

                      <div style={{ display: "flex", flexDirection: "column" }}> {subtotall < loyalty?.minRedeemPoints && (<span style={{ fontSize: "12px", color: "red" }}>
                        Subtotal points should more than or equal to min redeem points</span>)}
                        {subtotall >= loyalty?.minRedeemPoints && (<span style={{ fontSize: "12px", display: "flex", justifyContent: "flex-end" }}>
                          subtotal {subtotall.toFixed(2)} reduced from loyalty {profile?.loyaltyAmount.toFixed(2)}</span>)}</div></div>
                    ) : (<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", color: "red" }}><span style={{ fontSize: "12px" }}>
                      Not enough loyalty points to place order</span> </div>)}
                    {profile?.loyaltyAmount > subtotall
                      && (
                        <div className="row">
                          <div className="key">Final Total :</div>
                          <div className="value" style={{ display: "flex", flexDirection: "column" }}>
                            {/* <span> {"₹"} {subtotall.toFixed(2) <= profile?.loyaltyAmount ? 0 + (delivery === "FREIGHT FORWARD" ?
                              Number(calculatePackingCharge()) : 0) : subtotall.toFixed(2) + (delivery === "FREIGHT FORWARD" ?
                                Number(calculatePackingCharge()) : 0)}</span> */}
                            <span>₹ {Number(Math.round(grandTotal.toFixed(2)))}</span>
                          </div>
                        </div>)}
                  </div>)}
              </div>


              <div className="flex g-8">
                <B2BButton
                  name={
                    isPlacingOrder ? (
                      <>
                        <Loader size="sm" color="#8BC53F" style={{ marginRight: 8 }} /> Placing...
                      </>
                    ) : (
                      "Place Order"
                    )
                  }
                  color="#8BC53F"
                  disabled={isPlacingOrder || loyaltycondition || cartData.length < 1}
                  // onClick={() => {
                  //   if (grandTotal > 50000) {
                  //     setModalOpen(true);
                  //   } else {
                  //     handlePlaceOrder();
                  //   }
                  // }}
                  onClick={() => handlePlaceOrder(false)}
                  style={{
                    fontWeight: 600,
                    height: "48px",
                    boxShadow: "0 3px 6px 0 rgba(0,0,0,.16)",
                  }}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
